import React from "react";
import { useState, useEffect } from "react";
import { supabase } from "../supabaseClient";
import Sidebar from "../components/Sidebar";
import ContentHeader from "../components/ContentHeader";
import "./CircuitsListPage.css";
import CircuitList from "../components/CircuitList";

const CircuitsListPage = () => {
  const [circuits, setCircuits] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  const getUserCircuits = async () => {
    let { data: mycircuits, error: err } = await supabase
      .from("circuits")
      .select("*, frameworks (id, name, version), snapshot:snapshots (id, circuit_id)")
      .eq('is_deleted', false)
      .order("updated_at", { ascending: false });
    if (err) {
      setError("Failed to load circuits: " + err.message);
      setLoading(false);
      return;
    }
    setCircuits(mycircuits);
    setLoading(false);
  };

  const handeDeleteCircuit = async (circuitId) => {

    if (!window.confirm("Do you want to delete this circuit? All files and jobs will be deleted. This action is irreversible.")) {
      return;
    }

    setLoading(true);
    const { data, error } = await supabase.from("circuits").update({is_deleted: true}).eq('id', circuitId).select();
    if (error) {
      setError(error.message);
    }
    else {
      setCircuits(circuits.filter(f => f.id != circuitId));
    }
    setLoading(false);
  }

  useEffect(() => {
    getUserCircuits();
  }, []);

  return (
    <div
      className="columns"
      style={{ height: "100vh", display: "flex", flexDirection: "row" }}
    >
      <Sidebar />
      <div className="column p-6 has-background-light">
        <ContentHeader title="Circuits" subtitle="Explore your circuits" />
        {isLoading && <div className="skeleton-block mt-5 p-5" style={{ height: '600px' }}></div>}
        {error && <div className="notification is-danger mt-5" role="alert">
          <button className="delete" onClick={() => { setError(null) }}></button>
          <strong>Error:</strong> {error}
        </div>}
        {!error && !isLoading &&
          <CircuitList circuits={circuits} onDelete={handeDeleteCircuit} />
        }
      </div>
    </div>
  );
};

export default CircuitsListPage;
